module.exports = __webpack_public_path__ + "img/logo-outlined-sm.795c01c5.png";